import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Wildfire/FeatureServer/1&source=sd)
 *  */
const WILDFIRE_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.0015,
  colors.amber[300],
  0.0056,
  colors.orange[500],
  0.0136,
  colors.red[500],
  0.029,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Wildfire/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 0.029 – 0.07", 11],
    ["> 0.0136 – 0.029", 9],
    ["> 0.0056 – 0.0136", 7],
    ["> 0.0015 – 0.0056", 5],
    ["0 – 0.0015", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: WILDFIRE_STOPS[row[1] as number],
  }));
};

export const wildfires = {
  stops: WILDFIRE_STOPS,
  props: getLegendRows(),
};
